// extracted by mini-css-extract-plugin
export default {"modal":"_0aYKV0G1--AppDownloadModal_modal__RoQVU","closeButton":"_0aYKV0G1--AppDownloadModal_closeButton__VrT-v"};